import { useEffect, useState } from 'react'
import { Autocomplete, TextField, Typography, Box, Stack } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { getAllOrganisationUsers } from '../../../../store/agents/actions'
import { addUsersAndClassesToLearnerGroup } from '../../../../store/knowledge/actions'

import { useTranslation } from 'react-i18next'
import BasicModal from '@/components/UI/Dialog'

const AddExistingUsersToGroup = (props: any) => {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const { groupId }: any = useParams()
  const [users, setUsers] = useState([])
  const [selectedButtonTarget, setSelectedButtonTarget] = useState({
    user_ids: [],
    group_ids: [],
  })

  const getAllUsers = async () => {
    try {
      const response: any = await dispatch(getAllOrganisationUsers())
      const data: any = []
      response.users.forEach((element: any) => {
        data.push({
          _id: element._id,
          label: element.email,
          value: element.email,
        })
      })
      setUsers(data)
    } catch (error) {
      setUsers([])
    }
  }

  useEffect(() => {
    if (!props.show) {
      return
    }
    setSelectedButtonTarget({
      user_ids: [],
      group_ids: [],
    })
    getAllUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show])

  const createOrUpdateAgent = async () => {
    if (
      !selectedButtonTarget.group_ids.length &&
      !selectedButtonTarget.user_ids.length
    ) {
      return
    }

    let classUsers: any = []
    if (selectedButtonTarget && selectedButtonTarget.group_ids.length) {
      let students: any = []
      selectedButtonTarget.group_ids.forEach((classData: any) => {
        students.push(classData.studentGroupId)
      })
      classUsers = students
    }

    let temp: any = {
      user_ids: selectedButtonTarget.user_ids.map(d => d._id),
      group_ids: classUsers,
    }

    try {
      await dispatch(addUsersAndClassesToLearnerGroup(groupId, temp))

      props.confirmHandler()
    } catch (error: any) {
      console.error('🚀 ~ createOrUpdateAgent ~ error:', error)
    }
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      title={t('Add Learner')}
      sx={{ width: 500 }}
      footerActions={[
        {
          title: t('Cancel'),
          variant: 'outlined',
          onClick: props.onHide,
        },
        {
          title: props.editMode ? t('Update') : t('Add'),
          variant: 'contained',
          onClick: createOrUpdateAgent,
        },
      ]}
    >
      <Stack gap={3}>
        <Box>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            {t('Add a class into group')}
          </Typography>
          <Autocomplete
            multiple
            size="small"
            value={selectedButtonTarget.group_ids || []}
            onChange={(_event: any, newValue: any) => {
              setSelectedButtonTarget({
                ...selectedButtonTarget,
                group_ids: newValue,
              })
            }}
            options={props.classes || []}
            getOptionLabel={(option: any) => option.label || ''}
            isOptionEqualToValue={(option: any, value: any) =>
              option._id === value._id
            }
            renderInput={params => (
              <TextField {...params} placeholder={t('Classes')} />
            )}
          />
        </Box>

        <Box>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
            {t('Add by user email')}
          </Typography>
          <Autocomplete
            multiple
            size="small"
            value={selectedButtonTarget.user_ids || []}
            onChange={(_event: any, newValue: any) => {
              setSelectedButtonTarget({
                ...selectedButtonTarget,
                user_ids: newValue,
              })
            }}
            options={users || []}
            getOptionLabel={(option: any) => option.label || ''}
            isOptionEqualToValue={(option: any, value: any) =>
              option._id === value._id
            }
            renderInput={params => (
              <TextField {...params} placeholder={t('Select Users')} />
            )}
          />
        </Box>
      </Stack>
    </BasicModal>
  )
}

export default AddExistingUsersToGroup
